<template>
<div id="ap_transportistas" >
    <div>
        <v-breadcrumbs :items="breadcrumbs" >
            <v-icon slot="divider" >forward</v-icon>
        </v-breadcrumbs>
    </div>
    <v-container fluid fill-height>
        <v-layout align-top justify-top>
            <v-menu-lateral-apendice />
            <v-flex xs10>
                <base-material-card color="primary" icon="library_books" title="Transportistas" class="elevation-1 px-5 py-3" >
                    <v-card-actions>
                        <v-spacer></v-spacer>

                        <v-speed-dial direction="left" open-on-hover>
                            <template v-slot:activator>
                                <v-btn x-small fab dark color="primary" >
                                    <v-icon>reorder</v-icon>
                                </v-btn>
                            </template>

                            <exportar-excel :data="datafiltered" :exportFields="transportistas.camposexcel" name="Transportistas.xlsx" >
                                <v-btn fab dark x-small color="success" title="Exportar Registros" v-tippy>
                                    <v-icon dark>get_app</v-icon>
                                </v-btn>
                            </exportar-excel>
                            <upload-excel-component v-if="editable" :on-success="handleSuccess" :before-upload="beforeUpload" />
                            <exportar-excel v-if="editable" :data="transportistas.camposLayout" :exportFields="transportistas.encabezadoLayout" name="Layout Transportistas.xlsx" >
                                <v-btn fab dark x-small color="purple darken-2" title="Descargar Layout" v-tippy>
                                    <v-icon dark>receipt</v-icon>
                                </v-btn>
                            </exportar-excel>
                        </v-speed-dial>
                        &nbsp;
                        <v-btn v-if="editable" fab dark x-small color="secondary" slot="activator" @click.native="openModal(1)" title="Agregar Registro" v-tippy>
                            <v-icon dark>add</v-icon>
                        </v-btn>

                        <v-dialog v-model="modal" max-width="60%" style=" z-index: 400 !important;" >
                            <v-card>
                                <v-card-title>
                                    <v-card class="primary white--text titulomodal" >
                                        <v-icon class="white--text" @click.native="modal = false" >
                                            cancel
                                        </v-icon>&nbsp;
                                        <span class="subheading" >
                                            <strong>
                                                {{ update ? "Actualizar" : "Nuevo" }} Transportista
                                            </strong>
                                        </span>
                                    </v-card>                                    
                                </v-card-title>
                                <v-form ref="form" lazy-validation>
                                    <v-card-text>
                                        <v-container grid-list-md text-xs-center @keyup.enter="guardar()" >
                                            <v-row>
                                                <v-col xs="12" sm="6" md="6" lg="6" >
                                                    <v-text-field label="Metadato" type="text" v-model="model.metadato" :rules="[rules.required]" maxlength="20" ></v-text-field>
                                                </v-col>
                                                <v-col xs="12" sm="6" md="6" lg="6" >
                                                    <v-text-field label="Prefijo BL" type="text" v-model="model.prefijo_bl" maxlength="20" ></v-text-field>
                                                </v-col>  
                                            </v-row>       
                                            <v-row>                                                
                                                <v-col xs="12" sm="6" md="6" lg="6" >
                                                    <v-text-field label="Nombre del Transportista" type="text" v-model="model.nombre_transportista" :rules="[rules.required]" maxlength="350" ></v-text-field>
                                                </v-col>
                                                <v-col xs="12" sm="6" md="6" lg="6" >
                                                    <v-text-field label="RFC o NIF del Transportista" type="text" v-model="model.rfc_nif_transportista" :rules="[rules.required]" maxlength="20" ></v-text-field>
                                                </v-col>  
                                            </v-row>
                                            <v-row>
                                                <v-col xs="12" sm="6" md="6" lg="6" >
                                                    <v-text-field label="Modalidad de Transporte" type="text" v-model="model.modalidad_transporte" :rules="[rules.required]" maxlength="50" ></v-text-field>
                                                </v-col>
                                                <v-col xs="12" sm="6" md="6" lg="6" >
                                                    <v-text-field label="Representación en México" type="text" v-model="model.representacion_mexico" :rules="[rules.required]" maxlength="150" ></v-text-field>
                                                </v-col>  
                                            </v-row>       
                                            <v-row>
                                                <v-col xs="12" sm="6" md="6" lg="6" >
                                                    <v-text-field label="Nombre del Representante o Agente de Servicio" type="text" v-model="model.nombre_representante" :rules="[rules.required]" maxlength="350" ></v-text-field>
                                                </v-col>
                                                <v-col xs="12" sm="6" md="6" lg="6" >
                                                    <v-text-field label="RFC O NIF del Representante o Agente" type="text" v-model="model.rfc_nif_representante" :rules="[rules.required]" maxlength="20" ></v-text-field>
                                                </v-col>  
                                            </v-row>    
                                            <v-row>
                                                <v-col xs="12" sm="3" md="3" lg="3" >
                                                    <v-text-field label="Teléfono" type="text" v-model="model.telefono" maxlength="100" ></v-text-field>
                                                </v-col> 
                                                <v-col xs="12" sm="3" md="3" lg="3" >
                                                    <v-text-field label="Calle" type="text" v-model="model.calle" maxlength="150" ></v-text-field>
                                                </v-col> 
                                                <v-col xs="12" sm="3" md="3" lg="3" >
                                                    <v-text-field label="No. Exterior" type="text" v-model="model.numero_exterior" maxlength="15" ></v-text-field>
                                                </v-col> 
                                                <v-col xs="12" sm="3" md="3" lg="3" >
                                                    <v-text-field label="No. Interior" type="text" v-model="model.numero_interior" maxlength="15" ></v-text-field>
                                                </v-col>                                                 
                                            </v-row>
                                            <v-row>
                                                <v-col xs="12" sm="6" md="6" lg="6" >
                                                    <v-text-field label="Colonia" type="text" v-model="model.colonia" maxlength="100" ></v-text-field>
                                                </v-col>
                                                <v-col xs="12" sm="6" md="6" lg="6" >
                                                    <v-text-field label="Código Postal" type="text" v-model="model.codigo_postal" maxlength="10" ></v-text-field>
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col>
                                                    <!--OptionCombo: 1-Pais, 2-Pais,Estado, 3-Pais,Estado,Ciudad, 4-Pais,Estado,Municipio, 5-Pais,Estado,Ciudad,Municipio -->
                                                    <v-combo-paises :option_combos="5" :param_pais="model.pais" :param_estado="model.estado" :param_ciudad="model.ciudad" :param_municipio="model.municipio" :on-select-pais="selectComboPais" :on-select-estado="selectComboEstado" :on-select-ciudad="selectComboCiudad" :on-select-municipio="selectComboMunicipio" />
                                                </v-col>
                                            </v-row>

                                                                                                                            
                                        </v-container>
                                    </v-card-text>
                                </v-form>
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn @click.native="modal = false" >
                                        <v-icon>cancel</v-icon>Cancelar
                                    </v-btn>
                                    <v-btn color="success" :loading="loading" @click.native="guardar()" >
                                        <v-icon>done</v-icon>
                                        {{ update ? "Actualizar" : "Guardar" }}
                                    </v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-dialog>
                    </v-card-actions>

                    <v-card-text>
                        <div id="datagrid" >
                            <v-client-table ref="principalTable" :data="transportistas.items" :columns="columns" :options="options" class="elevation-2 pa-2" >
                                <template slot="noResults" >
                                    <v-alert :value="true" icon="info" color="info" >No se encontró ningún registro</v-alert>
                                </template>

                                <template slot="actions" slot-scope="props" >
                                    <v-speed-dial :id="props.row.id" direction="left" open-on-hover>
                                        <template v-slot:activator>
                                            <v-btn :id="props.row.id" x-small fab dark color="primary" >
                                                <v-icon>reorder</v-icon>
                                            </v-btn>
                                        </template>

                                        <v-btn x-small fab dark color="blue" @click.native="
                          getRegistro(props.row.id_transportista)
                        " title="Editar Registro" v-tippy>
                                            <v-icon>edit</v-icon>
                                        </v-btn>
                                        <v-btn x-small fab dark color="pink" @click.native="
                          deleteRegistro(props.row.id_transportista)
                        " title="Eliminar Registro" v-tippy>
                                            <v-icon>delete</v-icon>
                                        </v-btn>
                                    </v-speed-dial>
                                </template>

                            </v-client-table>
                        </div>
                    </v-card-text>
                </base-material-card>
            </v-flex>

        </v-layout>
    </v-container>

</div>
</template>

<script>
import axios from "axios";
import menuLateral from "@/views/apendices/MenuLateralApendice.vue";
import powerTitulo from "@/components/powerTitulo.vue";
import ComboPaises from '@/components/ComboPaises/index.vue';

export default {
    components: {
        "v-menu-lateral-apendice": menuLateral,
        "v-power-titulo": powerTitulo,
        "v-combo-paises": ComboPaises,
    },
    mounted() {},

    data: () => ({
        url_active: location.href,        
        editable: true,             
        title: "Transportistas",        
        breadcrumbs: [{
                text: "Inicio",
                disabled: false,
                to: "/home"
            },
            {
                text: "Utilerías",
                disabled: true,
                to: ""
            },
            {
                text: "Apéndices",
                disabled: true,
                to: ""
            }
        ],
        columns: [            
            "metadato",
            "nombre_transportista",
            "modalidad_transporte",
            "nombre_representante",
            "rfc_nif_representante",           
            "actions"
        ],
        options: {            
            headings: {
                "metadato":"Metadato",
                "nombre_transportista":"Transportista",
                "modalidad_transporte":"Modalidad Transporte",
                "nombre_representante":"Representante",
                "rfc_nif_representante":"RFC/NIF Representante",                            
                actions: "Operaciones"
            },            
        },
        URL: "",
        show_loading: true,
        loading: false,
        modal: false,
        update: false,
        search: "",
        model: {
            id_transportista: 0,
            metadato:"",
            prefijo_bl:"",
            nombre_transportista:"",
            rfc_nif_transportista:"",
            modalidad_transporte:"",
            representacion_mexico:"",
            nombre_representante:"",
            rfc_nif_representante:"",
            telefono:"",
            calle:"",
            numero_exterior:"",
            numero_interior:"",
            colonia:"",
            codigo_postal:"",
            ciudad:"",
            municipio:"",
            estado:"",
            pais:"",
        },
        rules: {
            required: v => !!v || "Este campo es requerido",            
        },
        transportistas: {
            selected: [],
            camposexcel: {
                "Metadato":"metadato",
                "Prefijo BL":"prefijo_bl",
                "Transportista":"nombre_transportista",
                "RFC/NIF Transportista":"rfc_nif_transportista",
                "Modalidad Transporte":"modalidad_transporte",
                "Representación México":"representacion_mexico",
                "Representante":"nombre_representante",
                "RFC/NIF Representante":"rfc_nif_representante",
                "Teléfono": "telefono",                
                "Calle": "calle",
                "No. Exterior": "numero_exterior",
                "No. Interior": "numero_interior",
                "Colonia": "colonia",
                "CP": "codigo_postal",
                "Ciudad": "ciudad",
                "Municipio": "municipio",
                "Estado": "estado_nombre",
                "Pais": "pais_nombre",
            },
    
            items: [0],
            //En el encabezado deben ser iguales los pares, respetando el nombre del campo definido en el modelo de la API
            encabezadoLayout: {                
                metadato:"metadato",
                prefijo_bl:"prefijo_bl",
                nombre_transportista:"nombre_transportista",
                rfc_nif_transportista:"rfc_nif_transportista",
                modalidad_transporte:"modalidad_transporte",
                representacion_mexico:"representacion_mexico",
                nombre_representante:"nombre_representante",
                rfc_nif_representante:"rfc_nif_representante",
                telefono:"telefono",
                calle:"calle",
                numero_exterior:"numero_exterior",
                numero_interior:"numero_interior",
                colonia:"colonia",
                codigo_postal:"codigo_postal",
                ciudad:"ciudad",
                municipio:"municipio",
                estado:"estado",
                pais:"pais",
            },
            //van vacíos para solo descargar layout con encabezados
            camposLayout: [{                
                metadato:"[Metadato]",
                prefijo_bl:"[Prefijo BL]",
                nombre_transportista:"[Nombre del Transportista]",
                rfc_nif_transportista:"[RFC o NIF del Transportista]",
                modalidad_transporte:"[Modalidad de Transporte]",
                representacion_mexico:"[Representación en México]",
                nombre_representante:"[Nombre del Representante o Agente de Servicio]",
                rfc_nif_representante:"[RFC O NIF del Representante o Agente]",
                telefono:"[Teléfono]",
                calle:"[Calle]",
                numero_exterior:"[No. Exterior]",
                numero_interior:"[No. Interior]",
                colonia:"[Colonia]",
                codigo_postal:"[CP]",
                ciudad:"[Clave de Ciudad]",
                municipio:"[Clave de Municipio]",
                estado:"[Clave de Estado]",
                
                pais:"[Clave de Pais]",
            }]
        },       
        camposObligatorios: {
            "metadato":"Metadato",            
            "nombre_transportista":"Nombre del Transportista",
            "rfc_nif_transportista":"RFC o NIF del Transportista",
            "modalidad_transporte":"Modalidad de Transporte",
            "representacion_mexico":"Representación en México",
            "nombre_representante":"Nombre del Representante o Agente de Servicio",
            "rfc_nif_representante":"RFC O NIF del Representante o Agente",
            "pais":"País",
        },

    }),
    computed: {
        datafiltered() {
            if (this.$refs.principalTable != null) {                
                return this.$refs.principalTable.allFilteredData;
            } else {
                return this.transportistas.items;
            }
        }
    },
    methods: {
        openModal: function (type) {
            if (type === 1) {
                this.limpiarModel();
                this.title = "Nuevo Transportista";
                this.update = false;
            } else {
                this.title = "Actualizar Transportista";
                this.update = true;
            }
            this.modal = true;
        },
        limpiarModel: function () {
            for (var k in this.model) {
                this.model[k] = "";
            }            
        },

        guardar() {
            const datos = this.model;

            if (!this.$refs.form.validate()) {
                //Alguna operación o mensaje
            } else {
                this.$root.$dialogLoader.show("ESPERE UN MOMENTO POR FAVOR..");
                var metodo = "post";
                var urlCliente = this.URL;
                if (this.update == true) {
                    metodo = "put";
                    urlCliente += this.model.id_transportista + "/";
                }
                axios({
                        method: metodo,
                        url: urlCliente,
                        data: datos
                    })
                    .then(res => {
                        this.$swal({
                            type: "success",
                            title: "¡Operación Exitosa!",
                            text: "Los datos se guardaron correctamente",
                            footer: ""
                        });
                        this.cargar();
                        this.$root.$dialogLoader.hide();
                        this.modal = false;
                    })
                    .catch(err => {
                        try {
                            var errores = "";
                            if (typeof err.response.data != "undefined") {
                                if (typeof err.response.data == "string") {
                                    let pos = errores.indexOf(err.response.data);
                                    if (pos < 0) {
                                        errores += err.response.data;
                                        errores += "<br>";
                                    }
                                } else{
                                    Object.keys(err.response.data).forEach(function (key) {
                                            var errors = err.response.data[key];                                            
                                            //Este trae 2 niveles, por eso el campo queda en la key2
                                            Object.keys(errors).forEach(function (key2) {
                                                let pos = errores.indexOf(key + ": " + errors[key2]);
                                                if (pos < 0) {
                                                    errores += key + ": " + errors[key2];
                                                    errores += "<br>";
                                                }
                                            });                                             
                                        });
                                }                                      
                                    
                            }
                                
                            this.$swal({
                                position: "center",
                                type: "error",
                                title: "¡Operación no Permitida!",
                                text: "Ocurrió un error al guardar los datos",
                                footer: errores,
                                //showConfirmButton: false,
                            });
                            //console.log(err);
                            this.cargar();
                            this.$root.$dialogLoader.hide();
                            this.modal = false;
                        } catch (error) {
                            console.log(error);
                        }
                        
                    });
            }
        },
        
        cargar: function () {
            this.$root.$dialogLoader.show("ESPERE UN MOMENTO POR FAVOR..");
            axios
                .get(this.URL)
                .then(res => {
                    if (typeof res.data !== "undefined") {
                        this.transportistas.items = res.data;
                        for (var k in this.transportistas.items) {
                            this.transportistas.items[k].pais_nombre = this.obtenerPais(this.transportistas.items[k].pais);                            
                            if (this.transportistas.items[k].estado != null)
                                this.transportistas.items[k].estado_nombre = this.obtenerEstado(this.transportistas.items[k].estado);
                        }
                        this.$root.$dialogLoader.hide();
                    }
                })
                .catch(err => {                   
                    console.log(err);
                    this.$root.$dialogLoader.hide();
                });
        },
        obtenerPais(id_pais) {
            let paises = this.paises.filter(function (e) {
                return e.id_pais == id_pais;
            });
            return paises.length > 0 ? paises[0].nombre : "N/A";
        },
        obtenerEstado(id_estado) {
            var estados = [];
            estados = this.estados_todos.filter(function (e) {
                return e.id_estado == id_estado;
            });
            return estados.length > 0 ? estados[0].nombre : "N/A";
        },
       
        getRegistro: function (id_registro) {
            this.$root.$dialogLoader.show("ESPERE UN MOMENTO POR FAVOR..");
            axios
                .get(this.URL + id_registro + "/")
                .then(response => {
                    this.model = response.data;   
                    this.cargarEstados(2);                 
                    this.openModal(2); //ACTUALIZAR
                })
                .catch(error => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener el registro",
                        footer: ""
                    });
                }).then(()=>{
                    this.$root.$dialogLoader.hide();
                });
        }, //getRegistro

        deleteRegistro: function (id_registro) {
            this.$swal({
                type: "info",
                title: "Cuidado",
                text: "¿Está seguro de eliminar el registro?",
                footer: "",
                showCancelButton: true,
                cancelButtonColor: "#d33",
                confirmButtonColor: "#3085d6",
                confirmButtonText: "Aceptar",
                cancelButtonText: "Cancelar"
            }).then(result => {
                if (result.value){
                    this.$root.$dialogLoader.show("ESPERE UN MOMENTO POR FAVOR..");
                    axios
                    .delete(this.URL + id_registro + "/")
                    .then(response => {
                        this.cargar();
                        this.$swal({
                            type: "success",
                            title: "Operación Exitosa",
                            text: "El registro se eliminó correctamente.",
                            footer: ""
                        });
                    })
                    .catch(error => {
                        this.$root.$dialogLoader.hide();
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "Ocurrió un error al eliminar el registro",
                            footer: ""
                        });
                    });
                }
                    
            });
        }, //delete
        
        beforeUpload(file) {
            const isLt2M = file.size / 1024 / 1024 < 2;

            if (isLt2M) {
                return true;
            }
            this.$swal({
                type: "warning",
                title: "¡Operación no Permitida!",
                text: "El archivo no debe ser mayor a 2MB.",
                footer: ""
            });
            return false;
        },
        verificaObligatorios: function (results) {
            var errores = '';
            var keys = [];
            for (var k in results) {
                keys.push(k);
            }

            for (var key in this.camposObligatorios) {
                if (keys.indexOf(key) == -1)
                    errores += '<br/>' + "- El campo '" + key + "' es obligatorio.";
            }

            return errores == '' ? true : errores;
        },
        validaCargaLayout: async function (results) {
            var thisObject = this;
            //return new Promise(function(resolve, reject){
            var errores = 0;
            var renglonesLeidos = 0;
            var erroresText = '';
            var aduanasContactoRfc = [];
            var aduanasDomicilioRfc = [];
            try {

                for (var k in results) {
                    renglonesLeidos++;
                    results[k]["user_updated"] = thisObject.$local_storage.get("email");                    
                    var obligatorios = thisObject.verificaObligatorios(results[k]);
                    if (obligatorios !== true) {
                        errores++;
                        if (erroresText.indexOf(obligatorios) == -1)
                            erroresText += obligatorios;
                    } else {
                                                
                        let clavesVacias = thisObject.verificaPaisesVacios(results[k]["pais"], results[k]["estado"], results[k]["ciudad"], results[k]["municipio"]);
                        if (clavesVacias.toString().trim().length > 0) {
                            errores++;
                            if (erroresText.indexOf(clavesVacias) == -1)
                                erroresText += clavesVacias;
                        } else {
                            if (results[k]["pais"] != undefined) {
                                let verificaPaises = await thisObject.verificaComboPaises(results[k]["pais"], results[k]["estado"], results[k]["ciudad"], results[k]["municipio"]);
                                if (verificaPaises.toString().trim().length > 0) {
                                    errores++;
                                    if (erroresText.indexOf(verificaPaises) == -1)
                                        erroresText += verificaPaises;
                                }
                            }
                        }


                    }
                    //console.log("Key is " + k + ", value is" + results[k]);
                }

                if (renglonesLeidos == 0) {
                    errores++;
                    erroresText += "- No hay datos en el layout. Verifique que exista información a partir del 3er renglón.\n";
                }

                return ({
                    "errores": errores,
                    "erroresText": erroresText
                });

            } catch (error) {
                console.log(error);
                thisObject.$swal({
                    type: "warning",
                    title: "¡Operación no Permitida!",
                    text: "Error al cargar el archivo. Verifique que no existan celdas vacías.",
                    footer: error.message,
                });
            }
            //}); //promise

        },
        handleSuccess: async function ({
            results,
            header
        }) {
            var errores = 0;
            var erroresText = '';
            this.importData = [];            
            try {                                
                let validaciones = await this.validaCargaLayout(results);                
                if (validaciones.errores > 0) {
                    this.$swal({
                        type: "warning",
                        title: "¡Operación no Permitida!",
                        text: "Existen errores al cargar el archivo. Corrija y vuelva a intentarlo.",
                        footer: validaciones.erroresText,
                    });
                    this.$root.$dialogLoader.hide();
                } else {  
                    this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');                  
                    for (var k in results) {
                        
                        var id_pais = results[k]["pais"] != undefined ? await this.verificaPais(results[k]["pais"], 'id') : '';
                        if (id_pais != '')
                            var id_estado = results[k]["estado"] != undefined ? await this.verificaEstado(results[k]["estado"], id_pais, 'id') : '';
                        else
                            var id_estado = '';

                        this.importData.push({
                            metadato: results[k]["metadato"],
                            prefijo_bl: results[k]["prefijo_bl"]!= undefined ? results[k]["prefijo_bl"]:"",
                            nombre_transportista:results[k]["nombre_transportista"],
                            rfc_nif_transportista:results[k]["rfc_nif_transportista"],
                            modalidad_transporte:results[k]["modalidad_transporte"],
                            representacion_mexico:results[k]["representacion_mexico"],
                            nombre_representante:results[k]["nombre_representante"],
                            rfc_nif_representante:results[k]["rfc_nif_representante"],

                            telefono: results[k]["telefono"]!= undefined ? results[k]["telefono"]:"",
                            calle: results[k]["calle"]!= undefined ? results[k]["calle"]:"",
                            numero_exterior: results[k]["numero_exterior"]!= undefined ? results[k]["numero_exterior"]:"",
                            numero_interior: results[k]["numero_interior"]!= undefined ? results[k]["numero_interior"]:"",
                            colonia: results[k]["colonia"]!= undefined ? results[k]["colonia"]:"",
                            codigo_postal: results[k]["codigo_postal"]!= undefined ? results[k]["codigo_postal"]:"",
                            ciudad: results[k]["ciudad"] != undefined ? await this.verificaCiudad(results[k]["ciudad"], id_pais, id_estado, 'id') : '',
                            municipio: results[k]["municipio"] != undefined ? await this.verificaMunicipio(results[k]["municipio"], id_pais, id_estado, 'id') : '',
                            estado: id_estado,
                            pais: id_pais,                            
                            user_updated: results[k]["user_updated"],
                        });
                   
                    }
                    
                    console.log("RESULTADO:",this.importData);
                    
                    axios
                        .post(this.URL + "importar_transportistas/", this.importData)
                        .then(() => {
                            this.$swal({
                                type: "success",
                                title: "¡Operación Exitosa!",
                                text: "Los datos se guardaron correctamente",
                                footer: ""
                            });
                        })
                        .catch(err => {
                            var errores = "";
                            if (typeof err.response.data != "undefined") {
                                for (var i = 0; i < err.response.data.length; i++) {
                                    Object.keys(err.response.data[i]).forEach(function (key) {
                                        errores +=
                                            "Fila " +
                                            (i + 3) +
                                            " => " +
                                            key +
                                            ": " +
                                            err.response.data[i][key];
                                        errores += "<br>";
                                    });
                                }
                            }
                            this.$swal({
                                type: "error",
                                title: "¡Operación no Permitida!",
                                text: "Existen errores al cargar el archivo. Corrija y vuelva a intentarlo. \nVerifique que los encabezados correspondan con el layout.",
                                footer: errores
                            });
                        })
                        .then(() => {
                            this.cargar();
                            this.$root.$dialogLoader.hide();
                        });
                }

            } catch (error) {
                this.$swal({
                    type: "warning",
                    title: "¡Operación no Permitida!",
                    text: "Error al cargar el archivo. Verifique que no existan celdas vacías.",
                    footer: error.message,
                });
                this.$root.$dialogLoader.hide();
            }
        },
        cargarPaises: function () {
            axios
                .get(this.$hostname + "paises/")
                .then(res => {
                    if (typeof res.data !== "undefined") this.paises = res.data;
                    else {
                        this.$swal({
                            type: "warning",
                            title: "Aviso",
                            text: "No se han ingresado datos al catálogo de países",
                            footer: ""
                        });
                    }
                })
                .catch(err => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener el catálogo de países.",
                        footer: ""
                    });
                    console.log(err);
                });
        },
        verificaPaisesVacios: function (clave_pais, clave_estado, clave_ciudad, clave_municipio) {
            var erroresText = '';
            if (clave_municipio != undefined && clave_estado == undefined)
                erroresText += "- La clave municipio \"" + clave_municipio + "\" no debe tener el estado vacío.<br>";
            if (clave_ciudad != undefined && clave_estado == undefined)
                erroresText += "- La clave ciudad \"" + clave_ciudad + "\" no debe tener el estado vacío.<br>";
            if (clave_estado != undefined && clave_pais == undefined)
                erroresText += "- La clave estado \"" + clave_estado + "\" no debe tener el país vacío.<br>";
            return erroresText;

        },
        verificaComboPaises: async function (clave_pais, clave_estado, clave_ciudad, clave_municipio) {
            var erroresText = '';
            let verificaP = await this.verificaPais(clave_pais, '');
            if (verificaP == 0) {
                erroresText += "- La clave país \"" + clave_pais + "\" no existe en el sistema.<br>";
            } else {
                let id_pais = await this.verificaPais(clave_pais, 'id');
                if (clave_estado != undefined) {
                    let verificaE = await this.verificaEstado(clave_estado, id_pais, '');
                    if (verificaE == 0) {
                        erroresText += "- La clave estado \"" + clave_estado + "\" no pertenece al país \"" + clave_pais + "\".<br>";
                    } else {
                        let id_estado = await this.verificaEstado(clave_estado, id_pais, 'id');
                        if (clave_ciudad != undefined) {
                            let verificaC = await this.verificaCiudad(clave_ciudad, id_pais, id_estado, '');
                            if (verificaC == 0)
                                erroresText += "- La clave ciudad \"" + clave_ciudad + "\" no pertenece al estado \"" + clave_estado + "\".<br>";
                        }
                        if (clave_municipio != undefined) {
                            let verificaM = await this.verificaMunicipio(clave_municipio, id_pais, id_estado, '');
                            if (verificaM == 0)
                                erroresText += "- La clave municipio \"" + clave_municipio + "\" no pertenece al estado \"" + clave_estado + "\".<br>";
                        }
                    }
                }

            }
            return erroresText;
        },
        verificaPais: function (clave_pais, opcion) {
            var thisObject = this;
            return new Promise(function (resolve, reject) {
                if (clave_pais == undefined)
                    resolve(0);

                var search = thisObject.paises.filter(function (e) {
                    return e.clave_m3.toString().trim().toLowerCase() == clave_pais.toString().trim().toLowerCase();
                });
                if (opcion == 'id')
                    resolve(search.length > 0 ? search[0].id_pais : '');
                else
                    resolve(search.length);
            });

        },
        verificaEstado: function (clave_estado, id_pais, opcion) {
            var thisObject = this;
            return new Promise(function (resolve, reject) {
                if (clave_estado == undefined)
                    resolve(0);

                var search = thisObject.estados_todos.filter(function (e) {
                    return e.clave.toString().trim().toLowerCase() == clave_estado.toString().trim().toLowerCase() &&
                        e.pais == id_pais;
                });
                if (opcion == 'id')
                    resolve(search.length > 0 ? search[0].id_estado : '');
                else
                    resolve(search.length);
            });
        },
        verificaCiudad: function (clave_ciudad, id_pais, id_estado, opcion) {
            var thisObject = this;
            return new Promise(function (resolve, reject) {
                if (clave_ciudad == undefined)
                    resolve(0);
                axios.post(thisObject.$hostname + "catalogos/ciudades/get_ciudades/", {
                        pais: id_pais,
                        estado: id_estado
                    })
                    .then(res => {
                        //console.log(clave_ciudad.toString().trim().trimLeft("0").toLowerCase()); 
                        if (typeof res.data !== "undefined") {
                            thisObject.ciudades = res.data;
                            var search = thisObject.ciudades.filter(function (e) {
                                //console.log("VERIFICA:"+thisObject.removeZerosLeft(e.clave.toString().trim().trimLeft("0").toLowerCase()));
                                return (parseInt(e.clave.toString().trim()) == parseInt(clave_ciudad.toString().trim())) || (e.clave.toString().trim() == clave_ciudad.toString().trim());
                            });
                            if (opcion == 'id')
                                resolve(search.length > 0 ? search[0].descripcion : '');
                            else
                                resolve(search.length);
                        }
                    })
                    .catch(err => {
                        console.log(err);
                        resolve(0);
                    });
            });
        },
        verificaMunicipio: function (clave_municipio, id_pais, id_estado, opcion) {
            var thisObject = this;
            return new Promise(function (resolve, reject) {
                if (clave_municipio == undefined)
                    resolve(0);
                axios.post(thisObject.$hostname + "catalogos/municipios/get_municipios/", {
                        pais: id_pais,
                        estado: id_estado
                    })
                    .then(res => {
                        if (typeof res.data !== "undefined") {
                            thisObject.municipios = res.data;
                            var search = thisObject.municipios.filter(function (e) {
                                return (parseInt(e.clave.toString().trim()) == parseInt(clave_municipio.toString().trim())) || (e.clave.toString().trim() == clave_municipio.toString().trim());
                            });
                            if (opcion == 'id')
                                resolve(search.length > 0 ? search[0].descripcion : '');
                            else
                                resolve(search.length);
                        }
                    })
                    .catch(err => {
                        console.log(err);
                        resolve(0);
                    });
            });
        },

        //Filtramos los estamos
        cargarEstados: function (opcion) {
            if (opcion == 1){
                //1-Limpiar estado seleccionado, 2-No limpiar
                this.model.estado = "";
            }
            if (this.model.pais == null) {
                this.estados = [];
            } else {
                let id_pais = this.model.pais;
                axios
                    .post(this.$hostname + "estados/get_estados_pais/", {
                        pais: id_pais
                    })
                    .then(res => {
                        if (typeof res.data !== "undefined") {
                            this.estados = res.data;
                        } else {
                            this.$swal({
                                type: "warning",
                                title: "Aviso",
                                text: "No se encontraron estados para el país seleccionado",
                                footer: ""
                            });
                        }
                    })
                    .catch(err => {
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "Ocurrió un error al obtener los estados asociados al país seleccionado.",
                            footer: ""
                        });
                        console.log(err);
                    });
            }
        },

        cargarEstadosTodos: function () {
            axios
                .get(this.$hostname + "estados/")
                .then(res => {
                    if (typeof res.data !== "undefined")
                        this.estados_todos = res.data;
                    else {
                        this.$swal({
                            type: "warning",
                            title: "Aviso",
                            text: "No se han ingresado datos al catálogo de estados",
                            footer: ""
                        });
                    }
                })
                .catch(err => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener el catálogo de estados.",
                        footer: ""
                    });
                    console.log(err);
                });
        },
        selectComboPais(id) {
            this.model.pais = id;
        },
        selectComboEstado(id) {
            this.model.estado = id;
        },
        selectComboCiudad(id) {
            this.model.ciudad = id;
        },
        selectComboMunicipio(id) {
            this.model.municipio = id;
        }, 

    }, //methods

    created: function () {
        this.URL = this.$hostname + "catalogos/ap_transportistas/";              
        this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
        this.id_cliente = this.$local_storage.get("id_cliente");
        if (this.id_cliente > 0) {
            this.editable = false;
            delete this.options.headings["actions"];
            var key = 0;
            for (var k in this.columns) {
                if (this.columns[k] == "actions") key = k;
            }
            if (key > 0) delete this.columns[key];
        }
        this.cargarPaises();
        this.cargarEstadosTodos();
        this.cargar();     
    }
};
</script>